module.exports = __webpack_public_path__ + "static/img/sleepq_logo.ced9b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sleepq_logo.png
// module id = Sb6j
// module chunks = 1